import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { TextInput } from '@/scopes/common/components/FormElements/TextInput'
import styles from '../Form.module.css'
import formInputStyles from './FormInput.module.css'

export function StreetNameInput({
  name,
  pattern,
  required,
}: {
  name: string
  pattern?: string
  required?: boolean
}) {
  const intl = useIntl()
  useTrackFieldValidation(name)

  return (
    <TextInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_street_name' })}
      required={required}
      pattern={pattern}
      patternErrorMessage={
        intl.formatMessage({ id: 'checkout_steps_participants_form_field_pattern_error_message_street_name' })
      }
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_street_name' })}
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldM)}
    />
  )
}
